import {
  useCancellationReasons,
  useCancellationReasonSettings,
  useDeleteCancellationReason,
  useUpdateCancellationReasonSettings,
  useUpsertCancellationReason,
} from "@coaching-culture/api-client";
import {
  AddButton,
  Circle,
  EmptyState,
  Flex,
  FormToggle,
  IconButton,
  Loader,
  Panel,
  SectionHeading,
  Text,
} from "@coaching-culture/ui";
import { FaCommentSlash, FaPen, FaTrash } from "react-icons/fa";

export const CancellationReasons = () => {
  const reasons = useCancellationReasons();
  const settings = useCancellationReasonSettings();
  const upsert = useUpsertCancellationReason();
  const del = useDeleteCancellationReason();
  const updateSettings = useUpdateCancellationReasonSettings();

  const edit = (id: string) => {
    const text = window.prompt(
      "Enter the edited cancellation reason.\n\nNOTE: This will change the text for any user that has used this cancellation reason and so this should only be used for minor copy changes or for new cancellation reasons.",
    );

    if (text) {
      upsert.mutateAsync({
        id,
        text,
      });
    }
  };

  const create = () => {
    const text = window.prompt("Enter the new cancellation reason.");

    if (text) {
      upsert.mutateAsync({ text });
    }
  };

  const deleteItem = (id: string) => {
    if (
      window.confirm(
        "Are you sure you want to delete this cancellation reason?\n\nAny conversations cancelled with this reason will lose that context.",
      )
    ) {
      del.mutateAsync(id);
    }
  };

  return (
    <>
      <SectionHeading>Cancellation Reasons</SectionHeading>
      <Panel p={3}>
        {reasons.data == null || settings.data == null ? (
          <Loader />
        ) : (
          <>
            <FormToggle
              mb={3}
              label="Require a cancellation reason"
              helpText={
                reasons.data.length === 0
                  ? "Create at least one cancellation reason to enable this setting"
                  : "Users must select a reason when cancelling a conversation"
              }
              value={settings.data.requireReason}
              disabled={reasons.data.length === 0}
              onChange={(val) =>
                updateSettings.mutateAsync({ requireReason: val })
              }
            />
            {reasons.data.length === 0 && (
              <EmptyState compact icon={FaCommentSlash} mb={2}>
                No cancellation reasons created yet.
              </EmptyState>
            )}
            {reasons.data.map((x) => (
              <Flex
                border={1}
                borderRadius={6}
                mb={2}
                alignItems={"center"}
                p={2}
              >
                <Circle icon={FaCommentSlash} color="primary" mr={2} />
                <Text style={{ flex: 1 }} fontWeight={500}>
                  {x.text}
                </Text>
                <IconButton
                  color="body"
                  icon={FaPen}
                  onClick={() => edit(x.id)}
                />
                <IconButton
                  ml={1}
                  color="danger"
                  icon={FaTrash}
                  onClick={() => deleteItem(x.id)}
                />
              </Flex>
            ))}
            <AddButton onClick={create}>
              Create New Cancellation Reason
            </AddButton>
          </>
        )}
      </Panel>
    </>
  );
};
